"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentTransport = void 0;
var analytics_node_1 = __importDefault(require("analytics-node"));
var spark_md5_1 = __importDefault(require("spark-md5"));
var AnalyticsConstants_1 = require("../AnalyticsConstants");
var SegmentTransport = /** @class */ (function () {
    function SegmentTransport(params) {
        this.segmentTransportParams = params;
        this.Analytics = new analytics_node_1.default(this.segmentTransportParams.key, {
            host: this.segmentTransportParams.host,
            flushInterval: this.segmentTransportParams.flushInterval || 1,
        });
    }
    SegmentTransport.prototype.send = function (sendable) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var sendableProperties = sendable.getProperties();
            var eventType = sendableProperties[AnalyticsConstants_1.AnalyticsConstants.Fields.EVENT_TYPE] || '';
            var callBack = function (error) {
                // ERR_INTERNET_DISCONNECTED -> No Internet
                // ERR_NETWORK_CHANGED -> your internet is connected but not working
                // ERR_NAME_NOT_RESOLVED -> when connected to switch but removed the ethernet cable or when the DNS cannot find a site's IP address
                if (error &&
                    (error.message === '' ||
                        error.message === 'ERR_INTERNET_DISCONNECTED' ||
                        error.message === 'ERR_NETWORK_CHANGED' ||
                        error.message === 'ERR_NAME_NOT_RESOLVED')) {
                    // TODO: need to raise issue in analytics-node repo for such error condition
                    reject(false);
                }
                else
                    resolve(true);
            };
            var userId = spark_md5_1.default.hash(sendableProperties.userId || 'tivo-webapp-loggers');
            // format the user id in below format:
            // 97b560ec-db99-90a3-7f4b-215d9c538bb5
            var match = userId.match(/^(\w{8})(\w{4})(\w{4})(\w{4})(\w+)$/);
            if (match) {
                userId = "".concat(match[1], "-").concat(match[2], "-").concat(match[3], "-").concat(match[4], "-").concat(match[5]);
            }
            switch (eventType) {
                case AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.IDENTIFY:
                    _this.Analytics.identify({
                        userId: userId,
                    }, callBack);
                    break;
                case AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.TRACK:
                    _this.Analytics.track({
                        userId: userId,
                        event: sendableProperties.event_name,
                        properties: JSON.parse(sendable.toSendable()),
                    }, callBack);
                    break;
                case AnalyticsConstants_1.AnalyticsConstants.SegmentEvents.SCREEN:
                    _this.Analytics.screen({
                        userId: userId,
                        name: sendableProperties.screenName,
                        properties: JSON.parse(sendable.toSendable()),
                    }, callBack);
                    break;
                // case AnalyticsConstants.SegmentEvents.PAGE:
                //     this.Analytics.page({ ...sendableProperties });
                //     break;
                // case AnalyticsConstants.SegmentEvents.ALIAS:
                //     this.Analytics.alias({ previousId: sendableProperties.previousId });
                //     break;
                // case AnalyticsConstants.SegmentEvents.GROUP:
                //     this.Analytics.group({ groupId: sendableProperties.groupId });
                //     break;
                default:
                // do nothing
            }
        });
    };
    return SegmentTransport;
}());
exports.SegmentTransport = SegmentTransport;
